import React from "react";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaCloudUploadAlt, FaSearch, FaFileAlt, FaPlus, FaSyncAlt } from "react-icons/fa";
import { MdVisibility } from "react-icons/md";
import { Button, Form, Table, Card, Badge, Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import getAllFormularios from "../../functions/getAllFormularios";
import eliminarProductoHome from "../../functions/eliminarProductoHome";
import filtrarDatos from "../../functions/filtrarDatos";
import { logBusinessAction } from "../../services/AuditService";

//modales
import ModalAñadir from "../../components/ModalAñadirReglamentos";
import ModalEditar from "../../components/ModalEditarReglamentos";
import BotonManualHeader from "../../components/BotonManualHeader";

function Reglamentos({ usuario }) {
  const ruc = usuario.ruc;
  const [productos, setProductos] = React.useState([]);
  const [isModalAñadir, setIsModalAñadir] = React.useState(false);
  const [isModalEditar, setIsModalEditar] = React.useState(false);
  const [productoEditar, setProductoEditar] = React.useState(null);
  const [searchTerm, setSearchTerm] = React.useState("");

  const baseDatos = `reglamentos`;
  
  async function busquedaFormHandler(e) {
    e.preventDefault();
    const busqueda = e.target.busqueda.value;
    const nvosDocus = await filtrarDatos(busqueda, baseDatos);
    setProductos(nvosDocus);
  }

  function actualizarEstadoProductos(db) {
    getAllFormularios(db, ruc).then((productos) => {
      // Ordenar por nombre alfabéticamente
      const productosOrdenados = productos.sort((a, b) => 
        a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      );
      setProductos(productosOrdenados);
    });
  }

  function añadirProductoHome() {
    setIsModalAñadir(true);
  }

  // Función para limpiar búsqueda
  const limpiarBusqueda = () => {
    const input = document.getElementById("busqueda");
    if (input) input.value = "";
    setSearchTerm("");
    actualizarEstadoProductos(baseDatos);
  };

  // Filtrar productos por término de búsqueda
  const productosFiltrados = productos.filter(producto =>
    producto.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
    producto.codigo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  React.useEffect(() => {
    actualizarEstadoProductos(baseDatos);
  }, [baseDatos]);

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium con degradado verde oscuro para Gestión de Documentos */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
              borderBottom: "3px solid #f39c12",
            }}
          >
            <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
              <BotonManualHeader usuario={usuario} />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaFileAlt className="me-3" />
                Biblioteca de Documentos
              </h2>
              <p className="mb-0 opacity-75">
                Gestiona los reglamentos y documentos de la empresa
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Modales */}
            <ModalAñadir
              isModalAñadir={isModalAñadir}
              setIsModalAñadir={setIsModalAñadir}
              actualizarEstadoProductos={actualizarEstadoProductos}
              usuario={usuario}
            />
            {productoEditar && (
              <ModalEditar
                isModalEditar={isModalEditar}
                setIsModalEditar={setIsModalEditar}
                actualizarEstadoProductos={actualizarEstadoProductos}
                productoEditar={productoEditar}
                setProductoEditar={setProductoEditar}
                usuario={usuario}
              />
            )}

            {/* Barra superior con acciones */}
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col md={1}>
                    <div
                      className="rounded-3 p-3 text-center"
                      style={{
                        background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        color: "white"
                      }}
                    >
                      <FaFileAlt size={24} />
                    </div>
                  </Col>
                  <Col md={7}>
                    <h5 className="mb-1 fw-semibold">Gestión de Documentos</h5>
                    <p className="text-muted mb-0 small">
                      Administra reglamentos, políticas y documentos corporativos
                    </p>
                  </Col>
                  <Col md={4} className="text-end">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Agregar nuevo documento</Tooltip>}
                    >
                      <Button
                        variant="light"
                        className="d-flex align-items-center gap-2"
                        onClick={añadirProductoHome}
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}
                      >
                        <FaPlus size="16px" />
                        Nuevo Documento
                      </Button>
                    </OverlayTrigger>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Barra de búsqueda mejorada */}
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Body className="p-3">
                <Form onSubmit={busquedaFormHandler}>
                  <Row className="g-2 align-items-center">
                    <Col md={8}>
                      <div className="position-relative">
                        <FaSearch 
                          className="position-absolute" 
                          style={{ 
                            left: "12px", 
                            top: "50%", 
                            transform: "translateY(-50%)", 
                            color: "#6c757d",
                            zIndex: 2
                          }} 
                        />
                        <Form.Control
                          id="busqueda"
                          type="text"
                          placeholder="Buscar documentos por nombre, código o revisión..."
                          className="form-control-lg ps-5"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{ 
                            borderRadius: "10px",
                            border: "2px solid #e9ecef"
                          }}
                        />
                      </div>
                    </Col>
                    <Col md={2}>
                      <Button
                        variant="primary"
                        type="submit"
                        className="w-100 d-flex align-items-center justify-content-center gap-2"
                        size="lg"
                        style={{
                          borderRadius: "10px",
                          background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                          border: "none",
                        }}
                      >
                        <FaSearch size="16px" />
                        Buscar
                      </Button>
                    </Col>
                    <Col md={2}>
                      <Button
                        variant="outline-secondary"
                        size="lg"
                        className="w-100 d-flex align-items-center justify-content-center gap-2"
                        onClick={limpiarBusqueda}
                        style={{ borderRadius: "10px" }}
                      >
                        <FaSyncAlt size="16px" />
                        Limpiar
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>

            {/* Estadísticas */}
            <Row className="mb-4">
              <Col md={4}>
                <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                  <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #1e7e34 0%, #20c997 100%)", color: "white", borderRadius: "15px" }}>
                    <h4 className="fw-bold">{productosFiltrados.filter(p => p.activo).length}</h4>
                    <p className="mb-0">Documentos Activos</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                  <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)", color: "white", borderRadius: "15px" }}>
                    <h4 className="fw-bold">{productosFiltrados.filter(p => !p.activo).length}</h4>
                    <p className="mb-0">Documentos Inactivos</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                  <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%)", color: "white", borderRadius: "15px" }}>
                    <h4 className="fw-bold">{productosFiltrados.length}</h4>
                    <p className="mb-0">Total Documentos</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Tabla de documentos */}
            <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "15px" }}>
              <Card.Header 
                className="text-white py-3"
                style={{ 
                  background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                  borderRadius: "15px 15px 0 0"
                }}
              >
                <div className="d-flex align-items-center">
                  <FaFileAlt className="me-2" />
                  <div className="flex-grow-1">
                    <h5 className="mb-0 fw-semibold">Lista de Documentos</h5>
                    <small className="opacity-75">
                      Gestiona todos los documentos corporativos
                    </small>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Badge bg="light" text="dark" style={{ fontSize: "0.9rem" }}>
                      {productosFiltrados.length} documentos
                    </Badge>
                  </div>
                </div>
              </Card.Header>

              <Card.Body className="p-0">
                {productosFiltrados.length > 0 ? (
                  <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    <Table hover responsive className="mb-0" style={{ fontSize: "0.9rem" }}>
                      <thead 
                        style={{
                          backgroundColor: "#f8f9fa",
                          position: "sticky",
                          top: 0,
                          zIndex: 10,
                        }}
                      >
                        <tr>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '5%' }}>
                            #
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '15%' }}>
                            Código
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '40%' }}>
                            Nombre del Documento
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '10%' }}>
                            Revisión
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '10%' }}>
                            Estado
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '10%' }}>
                            Ver
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '10%' }}>
                            Acciones
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {productosFiltrados.map((producto, index) => (
                          <tr key={index} style={{ borderBottom: "1px solid #f1f3f4" }}>
                            <td className="text-center py-3 px-3">
                              <Badge bg="dark" className="px-2 py-1">
                                {index + 1}
                              </Badge>
                            </td>
                            <td className="py-3 px-3">
                              <Badge 
                                bg="secondary" 
                                className="px-2 py-1"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {producto.codigo}
                              </Badge>
                            </td>
                            <td className="py-3 px-3">
                              <div className="d-flex align-items-center">
                                <div 
                                  className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                                    color: "white"
                                  }}
                                >
                                  <FaFileAlt size="14px" />
                                </div>
                                <div>
                                  <div className="fw-medium text-dark">
                                    {producto.nombre.length > 50 
                                      ? producto.nombre.substr(0, 50) + "..." 
                                      : producto.nombre}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="text-center py-3 px-3">
                              <Badge bg="info" className="px-2 py-1">
                                {producto.rev}
                              </Badge>
                            </td>
                            <td className="text-center py-3 px-3">
                              {producto.activo ? (
                                <Badge bg="success" className="px-2 py-1">Activo</Badge>
                              ) : (
                                <Badge bg="danger" className="px-2 py-1">Inactivo</Badge>
                              )}
                            </td>
                            <td className="text-center py-3 px-3">
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Ver documento</Tooltip>}
                              >
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  href={producto.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="d-flex align-items-center gap-1 mx-auto"
                                  style={{ borderRadius: "8px" }}
                                >
                                  <MdVisibility size="16px" />
                                </Button>
                              </OverlayTrigger>
                            </td>
                            <td className="text-center py-3 px-3">
                              <div className="d-flex gap-1 justify-content-center">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Editar documento</Tooltip>}
                                >
                                  <Button
                                    variant="outline-warning"
                                    size="sm"
                                    onClick={() => {
                                      setProductoEditar({ ...producto });
                                      setIsModalEditar(true);
                                    }}
                                    style={{ borderRadius: "6px" }}
                                  >
                                    <GrEdit size="14px" />
                                  </Button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Eliminar documento</Tooltip>}
                                >
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => {
                                      if (window.confirm("¿Estás seguro de que deseas eliminar este documento?")) {
                                        eliminarProductoHome(producto, usuario.email, baseDatos).then(
                                          async (confirmacion) => {
                                            actualizarEstadoProductos(baseDatos);
                                            // AUDITORÍA
                                            try {
                                              await logBusinessAction("ELIMINACION_REGLAMENTO_POLITICA", "GestionDocumentos", {
                                                documentoId: producto.id,
                                                codigo: producto.codigo,
                                                nombre: producto.nombre,
                                                revision: producto.rev
                                              }, usuario);
                                            } catch (e) {
                                              console.warn("No se pudo registrar la auditoría", e);
                                            }
                                          }
                                        );
                                      }
                                    }}
                                    style={{ borderRadius: "6px" }}
                                  >
                                    <RiDeleteBin6Fill size="14px" />
                                  </Button>
                                </OverlayTrigger>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <div
                      className="bg-light rounded-circle mx-auto mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaFileAlt size={32} className="text-muted" />
                    </div>
                    <h5 className="text-muted mb-2">No hay documentos disponibles</h5>
                    <p className="text-muted mb-3">
                      {searchTerm 
                        ? "No se encontraron documentos que coincidan con tu búsqueda"
                        : "Agrega tu primer documento haciendo clic en 'Nuevo Documento'"
                      }
                    </p>
                    {searchTerm && (
                      <Button
                        variant="outline-secondary"
                        onClick={limpiarBusqueda}
                        className="d-flex align-items-center gap-2 mx-auto"
                        style={{ borderRadius: "10px" }}
                      >
                        <FaSyncAlt size="14px" />
                        Limpiar búsqueda
                      </Button>
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default Reglamentos;